
export class AttendanceRequestModel {
  year:number;
  month: number;
  day: number;
  date: string;
  empId: number;
  attendanceStatus: string;
  otHours?: number;
  status: boolean;
  createdUser?: number;
  updatedUser?: number;
  versionFlag : number;
}

export class AttendanceProjectIDRequest {
  projectId: number;
  attenDate: string;
  subContractorId:number;
}

export const AttendanceRequestDefault: AttendanceRequestModel = {
  year:0,
  month: 0,
  day: 0,
  date: '',
  empId: 0,
  attendanceStatus: 'A',
  otHours: 0,
  status: true,
  createdUser : 0,
  updatedUser : 0,
  versionFlag : 1
}

